import {
  Avatar,
  BellIcon,
  Button,
  HeartIcon,
  Indicator,
  Modal,
  Stack,
  Text,
} from "@/components/ui/elements";

type Props = {
  opened: boolean;
  close: () => void;
};

export function FavoriteGuideModal({ opened, close }: Props) {
  return (
    <Modal opened={opened} close={close} size="sm">
      <Stack align="center" gap="md" py="md">
        <Indicator
          label={<HeartIcon color="white" size="0.8em" />}
          size={20}
          color="red"
          offset={4}
          position="bottom-end"
        >
          <Avatar color="teal" variant="light" radius="xl" size={64}>
            <BellIcon color="var(--mantine-color-teal-6)" size="1.8em" />
          </Avatar>
        </Indicator>

        <Text fw="bold" size="lg" ta="center">
          お気に入り登録
          <br />
          ありがとうございます！
        </Text>

        <Text ta="center" c="dimmed">
          この施設で新しい求人が公開されると、
          <br />
          通知でお知らせします
        </Text>

        <Button onClick={close} color="teal" fullWidth size="md">
          わかりました
        </Button>

        <Text size="xs" c="dimmed" ta="center">
          ※このお知らせは初回のみ表示されます
        </Text>
      </Stack>
    </Modal>
  );
}
